import React from 'react';
import PropTypes from 'prop-types';

import classes from './ReactHoneycombElement.module.scss';
import HoneycombElement from '../../../../components/HoneycombGrid/HoneycombElement';
import { GradientText } from '../../../../components';
import { DiReact } from 'react-icons/di';

const ReactIcon = () => <DiReact className={classes['icon']} />;

const ReactHoneycombElement = (props) => {
  const gradientOne = '#00b4d8';
  const gradientTwo = '#61DAFB';

  const Gradient = (text) => (
    <GradientText
      text={text}
      textFirstColor={gradientOne}
      textSecondColor={gradientTwo}
    />
  );

  return (
    <HoneycombElement
      id={props.id}
      title="React"
      category="Library"
      icon={ReactIcon}
      onFixPosition={props.onFixPosition}
      iconSizeAdapter="10%"
      titleColorFirst={gradientOne}
      titleColorSecond={gradientTwo}
    >
      <div className={classes['container']}>
        <h1 style={{ marginTop: '1em' }}>
          As {Gradient('reactive')} as {Gradient('possible')}
        </h1>
        <p>
          Learning React, the newest technology in my repertoire, marked my
          entry into web development. In fact, this website was built using this
          powerful JavaScript library.
        </p>
      </div>
    </HoneycombElement>
  );
};

ReactHoneycombElement.propTypes = {
  id: PropTypes.string.isRequired,
  onFixPosition: PropTypes.func.isRequired,
};

export default ReactHoneycombElement;
